// extracted by mini-css-extract-plugin
export var container = "_9e-0";
export var icon = "_9e-1";
export var text = "_9e-2";